import React from 'react';
import { Button } from '@chakra-ui/react';

const ContactButton = ({ 
  size = "md", 
  variant = "solid", 
  bg = "#ef3340", 
  color = "white",
  children = "Contactez-nous",
  ...props 
}) => {
  return (
    <Button
      bg={bg}
      color={color}
      size={size}
      fontWeight="bold"
      borderRadius="full"
      px={6}
      py={3}
      _hover={{ bg: '#d42b37', transform: "scale(1.05)" }}
      transition="all 0.2s"
      boxShadow="0 4px 14px 0 rgba(239, 51, 64, 0.3)"
      onClick={() => window.open('https://wa.me/33743641792', '_blank')}
      {...props}
    >
      {children}
    </Button>
  );
};

export default ContactButton;
